import React from 'react';
import { withAuthorization } from '../Session';

import { Container, Row, Col, Button, View, Form } from 'react-bootstrap';
import GCList from './gc-list';
import AllGCList from '../GiftCards/all-gc-list';



function AmazoneGiftCards(props) {
   

    return (
        <div>
            <AllGCList />
        </div>
    );
}


const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(AmazoneGiftCards)

